import { getAxiosInstance } from '@chr/online-shared-microsite-core';
import { AxiosInstance } from 'axios';
import { ConfigurationService } from '../../../config/configuration-service';
import * as ApiModel from '@/app/common/conversation/interfaces/api-model';

export const getConversation = async (request: ApiModel.IGetMessagesRequest) => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();
  const { supplierCode, customerCode } = request;
  const uri = `${poApiUri}/Conversations/${request.conversationId}/Messages?supplierCode=${supplierCode}&customerCode=${customerCode}`;
  const response = await axiosInstance.get(uri);

  return response.data;
};

export const createConversation = async (request: ApiModel.IPostPurchaseOrderConversationRequest): Promise<ApiModel.IPostPurchaseOrderConversationResponse> => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();
  const uri = `${poApiUri}/PurchaseOrders/Acknowledgement/${request.purchaseOrderId}/Conversation`;
  const response = await axiosInstance.post(uri, request);

  return response.data;
};

export const postConversationMessage = async (request: ApiModel.ICreateMessageRequest): Promise<void> => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();
  const uri = `${poApiUri}/Conversations/${request.conversationId}/Messages`;
  await axiosInstance.post(uri, request);
};

export const deleteMessageRecipient = async (request: ApiModel.IDeleteMessageRecipientRequest): Promise<void> => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();
  const uri = `${poApiUri}/Conversations/${request.conversationId}/MessageRecipient`;
  axiosInstance.delete(uri, { params: request });
};

export const createNote = async (request: ApiModel.IPostNoteRequest) => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();
  const { supplierCode, customerCode, entityType, entityId } = request;
  const uri = `${poApiUri}/Conversations/${entityType}/${entityId}/Notes?supplierCode=${supplierCode}&customerCode=${customerCode}`;
  const response = await axiosInstance.post(uri, request);
  return response.data;
};

export const getNotes = async (request: ApiModel.IGetNotesRequest) => {
  const axiosInstance: AxiosInstance = await getAxiosInstance();
  const { poApiUri } = await ConfigurationService.getConfiguration();
  const { supplierCode, customerCode, entityType, entityId } = request;
  const uri = `${poApiUri}/Conversations/${entityType}/${entityId}/Notes?supplierCode=${supplierCode}&customerCode=${customerCode}`;
  const response = await axiosInstance.get(uri);
  return response.data;
};
